import React from 'react';
import { View, Text, Image } from 'react-native';
import { normalize } from '../utils/normalize';
import wave from '../assets/images/wave.png';

const HeaderTitle = ({ icon, title, style }) => {
  return (
    <View style={[styles.container, style]}>
      <Image source={wave} style={styles.wave} />
      <View style={styles.header}>
        <View style={styles.iconContainer}>
          {icon}
        </View>
        <Text style={styles.headerName}>{title}</Text>
      </View>
    </View>
  );
};

const styles = {
  container: {
    position: 'relative',
  },
  wave: {
    position: 'absolute',
    top: -16,
    left: 0,
    right: 0,
    width: '100%',
    height: normalize(100),
    resizeMode: 'cover',
  },
  header: {
    flexDirection: 'row',
    alignItems: 'center',
    position: 'relative',
    zIndex: 1,
    paddingTop: normalize(20),
    paddingHorizontal: normalize(20),
    marginBottom: 16,
  },
  iconContainer: {
    zIndex: 1,
  },
  headerName: {
    fontSize: normalize(28),
    fontFamily: 'NotoSans-Bold',
    letterSpacing: -1,
    marginLeft: 10,
    zIndex: 1,
  },
};

export default HeaderTitle;